import * as React from "react";
import { ContentManagerContent } from "./components/ContentManagerContent";

export default function ContentManager() {
  return (
  <div className="p-4 w-full h-full flex flex-col min-h-screen bg-gray-100">
    
    <ContentManagerContent />
    </div>
  );
}


